import { render, staticRenderFns } from "./mobileTextbox.vue?vue&type=template&id=19e8153d&"
import script from "./mobileTextbox.vue?vue&type=script&lang=js&"
export * from "./mobileTextbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports